<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 107.5 199.961"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            :class="{active:blocks.root}"
            @click="select('root')"
            v-if="!noSegments"
            cx="33.774"
            cy="133.118"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M40.442 184.388c-5.284,3.645 -12.222,3.929 -20.814,0.852 6.567,9.804 14.44,11.547 23.621,5.229 5.074,-3.559 11.964,-3.164 20.67,1.186 0.807,0.403 1.629,0.84 2.467,1.311 9.319,0.728 16.007,-2.521 20.063,-9.749 -6.358,4.906 -13.405,4.176 -21.141,-2.189 -0.816,-0.587 -1.671,-1.075 -2.567,-1.464 -5.757,-2.498 -13.19,-0.89 -22.299,4.824z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            v-if="!noSegments"
            d="M62.995 159.893c-0.162,12.544 -0.247,19.101 -0.254,19.671 0.896,0.389 1.751,0.877 2.567,1.464 7.736,6.365 14.783,7.095 21.141,2.189 1.724,-3.072 2.973,-6.863 3.746,-11.372 0.573,-6.857 0.706,-13.161 0.401,-18.911 -9.269,3.658 -18.469,5.977 -27.601,6.959z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M62.995 159.893c9.132,-0.982 18.332,-3.301 27.601,-6.959 -0.041,-0.783 -0.091,-1.555 -0.149,-2.317 -4.567,-10.004 -19.02,-12.592 -43.357,-7.765 -13.385,0.953 -22.309,2.884 -26.772,5.791 -0.37,1.164 -0.736,2.107 -1.068,2.911 -0.267,0.772 -0.513,1.551 -0.738,2.34 8.381,3.213 16.821,5.243 25.323,6.088 6.353,0.632 12.74,0.602 19.16,-0.089z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M43.239 182.733l0.593 -22.752c-8.5,-0.845 -16.941,-2.875 -25.32,-6.087 -2.608,9.153 -2.33,19.457 0.831,30.913 0.095,0.146 0.19,0.29 0.285,0.433 8.592,3.077 15.53,2.793 20.814,-0.852 0.951,-0.596 1.883,-1.148 2.797,-1.655z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M62.73 179.564l0.265 -19.671c-6.425,0.692 -12.816,0.721 -19.172,0.089l-0.593 22.752c7.843,-4.35 14.343,-5.407 19.5,-3.17z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M20.318 148.643c4.463,-2.907 13.387,-4.838 26.772,-5.791 24.337,-4.827 38.79,-2.239 43.357,7.765m-26.528 41.038c0.556,2.241 -0.318,3.701 -2.622,4.38 -7.156,0.787 -13.172,-1.068 -18.048,-5.566m12.72 -141.24c-4.052,-5.918 -7.589,-10.136 -10.609,-12.654 -7.223,-5.215 -9.948,-0.821 -8.176,13.182m51.608 89.381c2.008,8.959 2.476,19.861 1.403,32.707 -2.593,15.119 -10.529,22.159 -23.809,21.121 -9.88,-5.553 -17.593,-6.386 -23.137,-2.497 -9.315,6.41 -17.283,4.522 -23.906,-5.662 -3.433,-12.443 -3.465,-23.527 -0.093,-33.253 1.056,-2.56 2.465,-6.528 3.201,-14.592 0.735,-8.064 0.799,-20.225 1.055,-30.466 0.256,-10.24 0.704,-18.56 0.896,-25.281 0.192,-6.72 0.128,-11.84 0.769,-16.417 0.639,-4.575 1.983,-8.608 3.296,-11.456 1.312,-2.848 2.592,-4.512 3.712,-5.473 1.12,-0.959 2.08,-1.215 3.264,-0.256 1.184,0.961 2.592,3.137 4.096,7.393 1.504,4.256 3.104,10.593 4.384,15.873 1.28,5.28 2.24,9.505 3.168,12.512 0.928,3.009 1.824,4.8 2.785,6.081 0.959,1.28 1.984,2.048 3.071,1.888 1.088,-0.16 2.241,-1.248 3.041,-3.2 0.8,-1.952 1.247,-4.768 1.28,-9.952 0.032,-5.185 -0.352,-12.737 -0.704,-17.538 -0.352,-4.8 -0.673,-6.848 -0.64,-9.856 0.032,-3.008 0.416,-6.976 0.896,-9.312 0.48,-2.336 1.056,-3.04 2.336,-1.857 1.28,1.185 3.264,4.257 4.928,7.169 1.664,2.912 3.008,5.664 5.217,11.201 2.207,5.536 5.279,13.856 7.583,21.312 2.305,7.457 3.841,14.049 5.153,20.449 1.312,6.401 2.4,12.608 3.36,18.849 0.96,6.24 1.792,12.513 2.337,15.937 0.544,3.424 0.801,4 1.058,4.576z"
        />
        <circle
            class="fil1 str1"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            v-if="!noSegments"
            cx="35.412"
            cy="33.938"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
